/* Partnership landing page behaviour.
   Ported from the Claude Design artboard's DCLogic component: scroll reveals,
   mobile carousels, the FAQ accordion, value-prop hover states, the timeline
   reflow and the enquiry form's button groups. */
(function () {
  'use strict';

  var INSTANCES = new WeakMap();

  function Partnership(root) {
    this.root = root;
    this.revealMotion = root.getAttribute('data-reveal-motion') || 'rise';
    this.stickyEnabled = root.getAttribute('data-sticky-cta') !== 'false';
    this.faqOpenByDefault = root.getAttribute('data-faq-open') !== 'false';
    this.observers = {};
    this.boot();
  }

  Partnership.prototype.boot = function () {
    var self = this;

    this.scan();
    this.sweep(false);
    this.revealStatus();
    this.safety = setTimeout(function () {
      self.sweep(true);
    }, 1800);

    this.onScroll = function () {
      self.sweep(false);
      self.updateSticky();
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });

    this.relayout = function () {
      self.layoutSteps();
      self.layoutVpGrid();
      self.layoutMobile();
      self.layoutEnquiry();
      self.updateSticky();
    };
    window.addEventListener('resize', this.relayout, { passive: true });

    if (window.ResizeObserver) {
      this.ro = new ResizeObserver(this.relayout);
      this.ro.observe(this.root);
    }
  };

  Partnership.prototype.destroy = function () {
    clearTimeout(this.safety);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.relayout);
    if (this.ro) this.ro.disconnect();
    var self = this;
    Object.keys(this.observers).forEach(function (k) {
      self.observers[k].disconnect();
    });
  };

  /* ---------------------------------------------------------------- reveal */

  Partnership.prototype.obs = function (margin) {
    var self = this;
    if (!this.observers[margin]) {
      this.observers[margin] = new IntersectionObserver(
        function (entries, o) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              self.show(e.target);
              o.unobserve(e.target);
            }
          });
        },
        { rootMargin: '0px 0px -' + margin + 'px 0px' }
      );
    }
    return this.observers[margin];
  };

  Partnership.prototype.show = function (el) {
    el.style.opacity = '1';
    el.style.transform = 'none';
    el.setAttribute('data-rv-done', '1');
  };

  Partnership.prototype.sweep = function (force) {
    var self = this;
    var vh = window.innerHeight || 800;
    this.root.querySelectorAll('[data-rv]:not([data-rv-done])').forEach(function (el) {
      var m = force ? 0 : el.getAttribute('data-rv') === '80' ? 80 : 60;
      var r = el.getBoundingClientRect();
      if (r.top < vh - m && r.bottom > 0) self.show(el);
    });
  };

  Partnership.prototype.scan = function () {
    var self = this;
    var mode = this.revealMotion;

    // {% form 'contact' %} renders the tag, so the hooks the rest of this file
    // looks for have to be attached here rather than authored in the markup
    var enquiry = this.root.querySelector('.pship-enquiry-form');
    if (enquiry && !enquiry.hasAttribute('data-enquiry-form')) {
      enquiry.setAttribute('data-enquiry-form', 'true');
      enquiry.setAttribute('data-rv', '80');
      // a posted form carries its status panel - show it outright rather than
      // making the visitor watch it fade in
      if (enquiry.querySelector('[data-enquiry-success], [data-enquiry-error]')) {
        enquiry.setAttribute('data-rv-init', '1');
        this.show(enquiry);
      }
    }

    this.root.querySelectorAll('[data-rv]:not([data-rv-init])').forEach(function (el) {
      el.setAttribute('data-rv-init', '1');
      if (mode === 'none') {
        el.style.transition = 'none';
        self.show(el);
        return;
      }
      if (mode === 'fade') el.style.transform = 'none';
      self.obs(el.getAttribute('data-rv') === '80' ? 80 : 60).observe(el);
    });

    this.wireArrows();
    this.wireCardLift();
    this.wireValueProps();
    this.wireFaq();
    this.wireForm();
    this.wireSticky();
    this.layoutSteps();
    this.layoutVpGrid();
    this.layoutMobile();
    this.layoutEnquiry();
  };

  Partnership.prototype.once = function (el, key) {
    if (el.getAttribute(key)) return false;
    el.setAttribute(key, '1');
    return true;
  };

  /* ------------------------------------------------------------ hover wiring */

  Partnership.prototype.wireArrows = function () {
    var self = this;
    this.root.querySelectorAll('[data-hover-lift]').forEach(function (el) {
      if (!self.once(el, 'data-w-lift')) return;
      var arrow = el.querySelector('[data-arrow]');
      el.addEventListener('mouseenter', function () {
        el.style.transform = 'scale(1.03)';
        if (arrow) arrow.style.transform = 'translateX(4px)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = 'none';
        if (arrow) arrow.style.transform = 'none';
      });
      el.addEventListener('mousedown', function () {
        el.style.transform = 'scale(.97)';
      });
      el.addEventListener('mouseup', function () {
        el.style.transform = 'scale(1.03)';
      });
    });
  };

  Partnership.prototype.wireCardLift = function () {
    var self = this;
    this.root.querySelectorAll('[data-card-lift]').forEach(function (el) {
      if (!self.once(el, 'data-w-card')) return;
      var base = el.style.boxShadow;
      var arrow = el.querySelector('[data-arrow]');
      var zoom = el.querySelector('[data-zoom]');
      el.addEventListener('mouseenter', function () {
        el.style.transform = 'translateY(-4px)';
        el.style.boxShadow = '0 25px 50px -12px rgba(0,0,0,.22)';
        if (arrow) arrow.style.transform = 'translateX(4px)';
        if (zoom) zoom.style.transform = 'scale(1.05)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = el.getAttribute('data-rv-init') ? 'none' : el.style.transform;
        el.style.boxShadow = base;
        if (arrow) arrow.style.transform = 'none';
        if (zoom) zoom.style.transform = 'none';
      });
    });
  };

  Partnership.prototype.wireValueProps = function () {
    var self = this;
    this.root.querySelectorAll('[data-vp]').forEach(function (card) {
      if (!self.once(card, 'data-w-vp')) return;
      card.addEventListener('mouseenter', function () {
        self.vpState(card, true);
      });
      card.addEventListener('mouseleave', function () {
        self.vpState(card, false);
      });
      card.addEventListener(
        'touchstart',
        function () {
          self.vpState(card, true);
        },
        { passive: true }
      );
      card.addEventListener('click', function () {
        self.vpState(card, !card.getAttribute('data-vp-on'));
      });
    });
  };

  Partnership.prototype.vpState = function (card, on) {
    var q = function (s) {
      return card.querySelector(s);
    };
    var layer = q('[data-vp-layer]');
    var img = q('[data-vp-img]');
    var wash = q('[data-vp-wash]');
    var shine = q('[data-vp-shine]');
    var icon = q('[data-vp-icon]');
    var title = q('[data-vp-title]');
    var body = q('[data-vp-body]');
    if (layer) {
      layer.style.opacity = on ? '1' : '0';
      layer.style.transform = on ? 'scale(1)' : 'scale(1.1)';
    }
    if (img) img.style.transform = on ? 'scale(1.05)' : 'scale(1)';
    if (wash) wash.style.opacity = on ? '0.55' : '0';
    if (shine) shine.style.transform = on ? 'translateX(400%)' : 'translateX(0)';
    if (icon) icon.style.transform = on ? 'scale(1.1) rotate(-6deg)' : 'none';
    if (title) title.style.color = on ? '#FFFFFF' : '#141A24';
    if (body) body.style.color = on ? 'rgba(255,255,255,.95)' : '#6B7280';
    card.style.boxShadow = on
      ? '0 25px 50px -12px rgba(0,0,0,.25)'
      : '0 1px 2px rgba(0,0,0,.05)';
    card.setAttribute('data-vp-on', on ? '1' : '');
  };

  /* ------------------------------------------------------------------- FAQ */

  Partnership.prototype.wireFaq = function () {
    var self = this;
    var items = Array.prototype.slice.call(this.root.querySelectorAll('[data-faq-item]'));
    var setOpen = function (el, open) {
      var panel = el.querySelector('[data-faq-a]');
      var chev = el.querySelector('[data-faq-chevron]');
      var btn = el.querySelector('[data-faq-q]');
      if (panel) panel.style.gridTemplateRows = open ? '1fr' : '0fr';
      if (chev) chev.style.transform = open ? 'rotate(180deg)' : 'none';
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      el.setAttribute('data-faq-open', open ? '1' : '');
    };
    items.forEach(function (item, i) {
      if (!self.once(item, 'data-w-faq')) return;
      var btn = item.querySelector('[data-faq-q]');
      if (i === 0 && self.faqOpenByDefault) setOpen(item, true);
      else setOpen(item, false);
      if (btn) {
        btn.addEventListener('click', function () {
          var willOpen = !item.getAttribute('data-faq-open');
          items.forEach(function (o) {
            setOpen(o, false);
          });
          if (willOpen) setOpen(item, true);
        });
      }
    });
  };

  /* -------------------------------------------------------- responsive mode */

  Partnership.prototype.mode = function () {
    var w = this.root.clientWidth;
    return w < 640 ? 'mobile' : w < 900 ? 'tablet' : 'desktop';
  };

  Partnership.prototype.isMobile = function () {
    return this.mode() === 'mobile';
  };

  Partnership.prototype.keep = function (el) {
    if (el && !el.hasAttribute('data-om-orig')) el.setAttribute('data-om-orig', el.style.cssText);
  };

  Partnership.prototype.give = function (el) {
    if (el && el.hasAttribute('data-om-orig')) {
      el.style.cssText = el.getAttribute('data-om-orig');
      el.removeAttribute('data-om-orig');
    }
  };

  Partnership.prototype.layoutMobile = function () {
    var self = this;
    var root = this.root;
    var mode = this.mode();
    var m = mode === 'mobile';
    var t = mode === 'tablet';
    if (this._mq === mode) {
      this.syncAllDots();
      return;
    }
    this._mq = mode;

    root.querySelectorAll('[data-screen-label]').forEach(function (s) {
      if (s.getAttribute('data-screen-label') === 'Hero') return;
      if (m) {
        self.keep(s);
        s.style.paddingTop = '48px';
        s.style.paddingBottom = '48px';
      } else {
        self.give(s);
      }
    });
    var last = root.querySelector('[data-screen-label="Enquiry"]');
    if (last && m) last.style.paddingBottom = '92px';

    ['paths', 'vp', 'platform'].forEach(function (key) {
      self.carousel(key, m);
    });

    if (!m) {
      ['paths', 'platform'].forEach(function (k) {
        var g = root.querySelector('[data-carousel="' + k + '"]');
        if (!g) return;
        if (t) {
          self.keep(g);
          g.style.gridTemplateColumns = 'repeat(2,minmax(0,1fr))';
          g.style.gap = '20px';
        } else {
          self.give(g);
        }
      });
    }

    var pbTabs = root.querySelector('[data-pb-tabs]');
    var pbGrid = root.querySelector('[data-pb-grid]');
    if (pbTabs && pbGrid) {
      if (m) {
        pbTabs.style.display = 'flex';
        this.keep(pbGrid);
        pbGrid.style.gridTemplateColumns = '1fr';
        if (!pbTabs.getAttribute('data-w')) {
          pbTabs.setAttribute('data-w', '1');
          pbTabs.addEventListener('click', function (e) {
            var tab = e.target && e.target.closest ? e.target.closest('[data-pb-tab]') : null;
            if (tab && pbTabs.contains(tab)) self.setPbTab(tab.getAttribute('data-pb-tab'));
          });
        }
        this.setPbTab(this._pbTab || 'provide');
      } else {
        pbTabs.style.display = 'none';
        this.give(pbGrid);
        root.querySelectorAll('[data-pb]').forEach(function (c) {
          c.style.display = '';
        });
        if (t) {
          this.keep(pbGrid);
          pbGrid.style.gridTemplateColumns = 'repeat(2,minmax(0,1fr))';
          pbGrid.style.gap = '20px';
          root.querySelectorAll('[data-pb]').forEach(function (c) {
            self.keep(c);
            c.style.padding = '26px 22px';
          });
        } else {
          root.querySelectorAll('[data-pb]').forEach(function (c) {
            self.give(c);
          });
        }
      }
    }

    var interest = root.querySelector('[data-interest]');
    var interestGrid = interest && interest.parentElement;
    if (interestGrid) {
      if (m) {
        this.keep(interestGrid);
        interestGrid.style.gridTemplateColumns = '1fr';
        interestGrid.style.gap = '6px';
        interestGrid.querySelectorAll('[data-interest]').forEach(function (b) {
          self.keep(b);
          b.style.padding = '11px 14px';
          b.style.fontSize = '13px';
        });
      } else {
        this.give(interestGrid);
        interestGrid.querySelectorAll('[data-interest]').forEach(function (b) {
          self.give(b);
        });
      }
    }

    var featImg = root.querySelector('[data-feat-img]');
    if (featImg) {
      if (m) {
        this.keep(featImg);
        featImg.style.minHeight = '210px';
      } else {
        this.give(featImg);
      }
    }

    var moreToggle = root.querySelector('[data-more-toggle]');
    var moreEls = Array.prototype.slice.call(root.querySelectorAll('[data-more="feat"]'));
    if (moreToggle) {
      if (m) {
        moreToggle.style.display = 'inline-flex';
        if (!this._moreOpen) {
          moreEls.forEach(function (e) {
            self.keep(e);
            e.style.display = 'none';
          });
        }
        if (!moreToggle.getAttribute('data-w')) {
          moreToggle.setAttribute('data-w', '1');
          var fire = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            self._moreOpen = !self._moreOpen;
            moreEls.forEach(function (e) {
              e.style.display = self._moreOpen ? '' : 'none';
            });
            moreToggle.textContent = self._moreOpen ? 'Show less' : 'Read more';
          };
          moreToggle.addEventListener('click', fire);
          moreToggle.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') fire(e);
          });
        }
      } else {
        moreToggle.style.display = 'none';
        moreEls.forEach(function (e) {
          self.give(e);
        });
      }
    }

    var bar = root.querySelector('[data-optional-bar]');
    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-optional]'));
    if (bar) {
      if (m) {
        bar.style.display = 'block';
        if (!this._optOpen) {
          opts.forEach(function (e) {
            self.keep(e);
            e.style.display = 'none';
          });
        }
        var btn = bar.querySelector('[data-optional-toggle]');
        if (btn && !btn.getAttribute('data-w')) {
          btn.setAttribute('data-w', '1');
          btn.addEventListener('click', function () {
            self._optOpen = !self._optOpen;
            opts.forEach(function (e) {
              e.style.display = self._optOpen ? '' : 'none';
            });
            var chev = bar.querySelector('[data-optional-chev]');
            if (chev) chev.style.transform = self._optOpen ? 'rotate(180deg)' : 'none';
            var lbl = btn.querySelector('span');
            if (lbl) lbl.textContent = self._optOpen ? 'Hide optional detail' : 'Add optional detail';
          });
        }
      } else {
        bar.style.display = 'none';
        opts.forEach(function (e) {
          self.give(e);
        });
      }
    }

    if (m) {
      root.querySelectorAll('[data-vp]').forEach(function (c) {
        if (!c.getAttribute('data-vp-m')) {
          c.setAttribute('data-vp-m', '1');
          self.vpState(c, true);
        }
      });
    } else {
      root.querySelectorAll('[data-vp][data-vp-m]').forEach(function (c) {
        c.removeAttribute('data-vp-m');
        self.vpState(c, false);
      });
    }
  };

  Partnership.prototype.setPbTab = function (name) {
    this._pbTab = name;
    this.root.querySelectorAll('[data-pb]').forEach(function (c) {
      c.style.display = c.getAttribute('data-pb') === name ? '' : 'none';
    });
    this.root.querySelectorAll('[data-pb-tab]').forEach(function (b) {
      var on = b.getAttribute('data-pb-tab') === name;
      b.style.background = on ? '#141A24' : 'transparent';
      b.style.color = on ? '#FFFFFF' : '#141A24';
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  };

  /* ------------------------------------------------------------- carousels */

  Partnership.prototype.carousel = function (key, on) {
    var self = this;
    var root = this.root;
    var grid = root.querySelector('[data-carousel="' + key + '"]');
    var rail = root.querySelector('[data-dots="' + key + '"]');
    if (!grid) return;
    var kids = Array.prototype.slice.call(grid.children);
    if (on) {
      var sec = grid.closest('section');
      var pad = sec ? parseFloat(getComputedStyle(sec).paddingLeft) || 24 : 24;
      this.keep(grid);
      grid.style.display = 'flex';
      grid.style.gridTemplateColumns = '';
      grid.style.overflowX = 'auto';
      grid.style.overflowY = 'hidden';
      grid.style.scrollSnapType = 'x mandatory';
      grid.style.gap = '14px';
      grid.style.marginLeft = '-' + pad + 'px';
      grid.style.marginRight = '-' + pad + 'px';
      grid.style.paddingLeft = pad + 'px';
      grid.style.paddingRight = pad + 'px';
      grid.style.scrollPaddingLeft = pad + 'px';
      grid.style.webkitOverflowScrolling = 'touch';
      kids.forEach(function (k) {
        self.keep(k);
        k.style.flex = '0 0 84%';
        k.style.minWidth = '0';
        k.style.scrollSnapAlign = 'start';
      });
      if (rail) {
        rail.style.display = 'flex';
        if (!rail.getAttribute('data-w')) {
          rail.setAttribute('data-w', '1');
          rail.addEventListener('click', function (e) {
            var dot = e.target && e.target.closest ? e.target.closest('[data-dot]') : null;
            if (!dot || dot.parentElement !== rail) return;
            var i = Array.prototype.indexOf.call(rail.children, dot);
            var kid = grid.children[i];
            if (!kid) return;
            var left =
              grid.scrollLeft +
              kid.getBoundingClientRect().left -
              grid.getBoundingClientRect().left -
              parseFloat(getComputedStyle(grid).paddingLeft || '0');
            grid.style.scrollSnapType = 'none';
            grid.scrollTo({ left: left, behavior: 'smooth' });
            clearTimeout(grid._snapBack);
            grid._snapBack = setTimeout(function () {
              grid.style.scrollSnapType = 'x mandatory';
            }, 520);
          });
          grid.addEventListener(
            'scroll',
            function () {
              self.syncDots(key);
            },
            { passive: true }
          );
        }
      }
      this.syncDots(key);
    } else {
      this.give(grid);
      kids.forEach(function (k) {
        self.give(k);
      });
      if (rail) rail.style.display = 'none';
    }
  };

  Partnership.prototype.syncAllDots = function () {
    var self = this;
    ['paths', 'vp', 'platform'].forEach(function (k) {
      self.syncDots(k);
    });
  };

  Partnership.prototype.syncDots = function (key) {
    var root = this.root;
    var grid = root.querySelector('[data-carousel="' + key + '"]');
    var rail = root.querySelector('[data-dots="' + key + '"]');
    if (!grid || !rail || rail.style.display === 'none') return;
    var kids = Array.prototype.slice.call(grid.children);
    if (kids.length < 2) return;
    var step = kids[1].getBoundingClientRect().left - kids[0].getBoundingClientRect().left;
    var idx = step > 0 ? Math.max(0, Math.min(kids.length - 1, Math.round(grid.scrollLeft / step))) : 0;
    var accent = key === 'vp' ? '#E83041' : '#3987E0';
    Array.prototype.slice.call(rail.children).forEach(function (d, i) {
      var on = i === idx;
      d.style.width = on ? '22px' : '8px';
      d.style.background = on ? accent : 'rgba(20,26,36,.22)';
    });
  };

  /* ----------------------------------------------------------------- toast */

  Partnership.prototype.toast = function (title, desc, tone) {
    var host = this.root.querySelector('[data-toast-host]');
    if (!host) return;
    var bad = tone === 'error';
    var el = document.createElement('div');
    el.style.cssText =
      'pointer-events:auto;max-width:340px;background:#FFFFFF;color:#141A24;border:1px solid #E2E4EA;border-radius:14px;padding:14px 16px;box-shadow:0 20px 40px -12px rgba(0,0,0,.3);font-family:Inter,sans-serif;opacity:0;transform:translateX(16px);transition:opacity .3s ease,transform .3s ease';
    var t = document.createElement('div');
    t.style.cssText = 'display:flex;align-items:center;gap:8px;font-size:14px;font-weight:700';
    t.innerHTML =
      '<span style="display:grid;place-items:center;height:18px;width:18px;border-radius:999px;background:' +
      (bad ? '#E83041' : '#1FB36B') +
      ';color:#fff;flex-shrink:0"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">' +
      (bad ? '<path d="M12 7v6"/><path d="M12 17h.01"/>' : '<path d="M20 6 9 17l-5-5"/>') +
      '</svg></span>';
    t.appendChild(document.createTextNode(title));
    var d = document.createElement('div');
    d.style.cssText = 'margin-top:6px;font-size:13px;color:#6B7280;line-height:1.5';
    d.textContent = desc;
    el.appendChild(t);
    el.appendChild(d);
    host.appendChild(el);
    requestAnimationFrame(function () {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    setTimeout(function () {
      el.style.opacity = '0';
      el.style.transform = 'translateX(16px)';
      setTimeout(function () {
        el.remove();
      }, 350);
    }, 4600);
  };

  /* ---------------------------------------------------------------- layout */

  Partnership.prototype.layoutVpGrid = function () {
    var grid = this.root.querySelector('[data-vp-grid]');
    if (!grid || this.isMobile()) return;
    var w = grid.clientWidth;
    var n = w >= 1180 ? 4 : w >= 620 ? 2 : 1;
    grid.style.gridTemplateColumns = 'repeat(' + n + ',minmax(0,1fr))';
  };

  Partnership.prototype.layoutEnquiry = function () {
    var root = this.root;
    var img = root.querySelector('[data-enq-img]');
    var form = root.querySelector('[data-enquiry-form]');
    if (!img || !form) return;
    var container = form.parentElement;
    var leftCol = container.firstElementChild;
    if (!leftCol) return;
    if (!this._enqHome) this._enqHome = { parent: img.parentElement, next: img.nextElementSibling };

    var wrapped = Math.abs(form.offsetTop - leftCol.offsetTop) > 20;
    if (wrapped === this._enqWrapped) return;
    this._enqWrapped = wrapped;

    if (wrapped) {
      if (img.parentElement !== container) container.appendChild(img);
      img.style.flex = '1 1 100%';
      img.style.width = '100%';
      img.style.maxWidth = '560px';
      img.style.marginTop = '24px';
      img.style.alignSelf = 'center';
    } else {
      if (img.parentElement !== this._enqHome.parent) {
        this._enqHome.parent.insertBefore(img, this._enqHome.next);
      }
      img.style.flex = '';
      img.style.width = '';
      img.style.maxWidth = '';
      img.style.marginTop = '32px';
      img.style.alignSelf = '';
    }
  };

  Partnership.prototype.layoutSteps = function () {
    var self = this;
    var line = this.root.querySelector('[data-steps-line]');
    if (!line) return;
    var grid = line.nextElementSibling;
    if (!grid || !grid.clientWidth) return;

    // five across needs real room; anything less becomes a vertical timeline
    // rather than a wrapped grid that orphans the last step
    var compact = grid.clientWidth < 860;
    if (this._stepsCompact === compact) return;
    this._stepsCompact = compact;
    var steps = Array.prototype.slice.call(grid.children);

    if (compact) {
      this.keep(grid);
      grid.style.gridTemplateColumns = '1fr';
      grid.style.gap = '0px';
      steps.forEach(function (s, i) {
        self.keep(s);
        s.style.display = 'grid';
        s.style.gridTemplateColumns = '48px 1fr';
        s.style.columnGap = '16px';
        s.style.alignItems = 'start';
        s.style.paddingBottom = i === steps.length - 1 ? '0px' : '22px';
        var chip = s.children[0];
        var h3 = s.children[1];
        var p = s.children[2];
        if (chip) {
          self.keep(chip);
          chip.style.height = '48px';
          chip.style.width = '48px';
          chip.style.borderRadius = '14px';
          chip.style.fontSize = '16px';
          chip.style.gridRow = '1 / span 2';
          chip.style.boxShadow = '0 0 0 4px #F7F4EE';
        }
        if (h3) {
          self.keep(h3);
          h3.style.margin = '0';
          h3.style.gridColumn = '2';
          h3.style.fontSize = '19px';
          h3.style.alignSelf = 'center';
        }
        if (p) {
          self.keep(p);
          p.style.margin = '4px 0 0';
          p.style.gridColumn = '2';
          p.style.fontSize = '14px';
          p.style.maxWidth = '54ch';
        }
      });
      this.keep(line);
      line.style.top = '24px';
      line.style.bottom = '24px';
      line.style.left = '23px';
      line.style.right = 'auto';
      line.style.width = '2px';
      line.style.height = 'auto';
      line.style.background = 'linear-gradient(180deg,#E83041,#3987E0,#1FB36B)';
      line.style.display = 'block';
    } else {
      this.give(grid);
      steps.forEach(function (s) {
        self.give(s);
        Array.prototype.slice.call(s.children).forEach(function (c) {
          self.give(c);
        });
      });
      this.give(line);
      grid.style.gridTemplateColumns = 'repeat(5,minmax(0,1fr))';
      line.style.display = 'block';
    }
  };

  /* ------------------------------------------------------------------ form */

  Partnership.prototype.wireForm = function () {
    var self = this;
    var form = this.root.querySelector('[data-enquiry-form]');
    if (!form || !this.once(form, 'data-w-form')) return;

    var interestValue = form.querySelector('[data-interest-value]');
    var yesnoValue = form.querySelector('[data-yesno-value]');
    var detail = form.querySelector('[data-business-detail]');
    var interests = Array.prototype.slice.call(form.querySelectorAll('[data-interest]'));
    var yesno = Array.prototype.slice.call(form.querySelectorAll('[data-yesno]'));

    var offInterest = function (b) {
      b.style.background = '#FFFFFF';
      b.style.color = '#141A24';
      b.style.borderColor = '#E2E4EA';
      b.style.boxShadow = 'none';
      b.removeAttribute('data-on');
      b.setAttribute('aria-pressed', 'false');
    };
    var onInterest = function (b) {
      b.style.background = '#3987E0';
      b.style.color = '#FFFFFF';
      b.style.borderColor = '#3987E0';
      b.style.boxShadow = '0 4px 6px -1px rgba(0,0,0,.12)';
      b.setAttribute('data-on', '1');
      b.setAttribute('aria-pressed', 'true');
    };
    var syncInterest = function () {
      if (!interestValue) return;
      interestValue.value = interests
        .filter(function (b) {
          return b.getAttribute('data-on');
        })
        .map(function (b) {
          return b.textContent.trim();
        })
        .join(', ');
    };

    interests.forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () {
        if (b.getAttribute('data-on')) offInterest(b);
        else onInterest(b);
        syncInterest();
      });
      b.addEventListener('mouseenter', function () {
        if (!b.getAttribute('data-on')) b.style.borderColor = 'rgba(57,135,224,.5)';
      });
      b.addEventListener('mouseleave', function () {
        if (!b.getAttribute('data-on')) b.style.borderColor = '#E2E4EA';
      });
    });

    var offYesno = function (o) {
      o.style.background = '#FFFFFF';
      o.style.color = '#141A24';
      o.style.borderColor = '#E2E4EA';
      o.removeAttribute('data-on');
      o.setAttribute('aria-pressed', 'false');
    };
    var pickYesno = function (b) {
      yesno.forEach(offYesno);
      b.style.background = '#141A24';
      b.style.color = '#FFFFFF';
      b.style.borderColor = '#141A24';
      b.setAttribute('data-on', '1');
      b.setAttribute('aria-pressed', 'true');
      if (yesnoValue) yesnoValue.value = b.getAttribute('data-yesno') === 'yes' ? 'Yes' : 'No';
      if (detail) detail.style.display = b.getAttribute('data-yesno') === 'yes' ? 'block' : 'none';
    };

    yesno.forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () {
        pickYesno(b);
      });
      b.addEventListener('mouseenter', function () {
        if (!b.getAttribute('data-on')) b.style.borderColor = 'rgba(20,26,36,.4)';
      });
      b.addEventListener('mouseleave', function () {
        if (!b.getAttribute('data-on')) b.style.borderColor = '#E2E4EA';
      });
    });

    // the browser restores input values (hidden ones included) on back/forward
    // navigation, so re-derive the button states from them. Liquid cannot help
    // here: the contact form object exposes only body, email, errors and id.
    if (interestValue && interestValue.value) {
      var chosen = interestValue.value.split(',').map(function (s) {
        return s.trim();
      });
      interests.forEach(function (b) {
        if (chosen.indexOf(b.textContent.trim()) > -1) onInterest(b);
      });
    }
    if (yesnoValue && yesnoValue.value) {
      var want = yesnoValue.value.toLowerCase();
      yesno.forEach(function (b) {
        if (b.getAttribute('data-yesno') === want) pickYesno(b);
      });
    }

    // the two button groups are not native controls, so required= cannot cover
    // them - block submission here instead
    form.addEventListener('submit', function (e) {
      var missing = null;
      if (interestValue && !interestValue.value) missing = interests[0];
      else if (yesnoValue && !yesnoValue.value) missing = yesno[0];
      if (!missing) return;
      e.preventDefault();
      self.toast(
        'A couple of answers are missing.',
        missing === interests[0]
          ? 'Choose at least one partnership interest.'
          : 'Let us know whether you currently operate a business.',
        'error'
      );
      missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
      missing.focus();
    });
  };

  /* --------------------------------------------------------- post-submit view */

  // Shopify redirects back to #PartnershipEnquiryForm, but the browser scrolls
  // there before layoutMobile and the carousels have shrunk every section above
  // the form - which drags the form up past the viewport. So re-aim at the
  // status panel ourselves, and again once layout and webfonts have settled.
  Partnership.prototype.revealStatus = function () {
    var panel = this.root.querySelector('[data-enquiry-success], [data-enquiry-error]');
    if (!panel) return;

    var interrupted = false;
    var stop = function () {
      interrupted = true;
    };
    ['wheel', 'touchstart', 'keydown'].forEach(function (evt) {
      window.addEventListener(evt, stop, { passive: true, once: true });
    });

    var settle = function () {
      if (interrupted) return;
      // the theme's header can be sticky, and would sit over the panel
      var header = document.querySelector('sticky-header, .shopify-section-header-sticky');
      var offset = (header ? header.offsetHeight : 0) + 24;
      var y = panel.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, y), behavior: 'instant' });
    };

    settle();
    requestAnimationFrame(settle);
    setTimeout(settle, 300);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(settle);
  };

  /* ------------------------------------------------------------- sticky CTA */

  Partnership.prototype.wireSticky = function () {
    this.stickyBar = this.root.querySelector('[data-sticky-cta]');
    this.updateSticky();
  };

  Partnership.prototype.updateSticky = function () {
    var bar = this.stickyBar;
    if (!bar) return;
    var enquiry = this.root.querySelector('#enquiry');
    var past = enquiry ? enquiry.getBoundingClientRect().top < window.innerHeight * 0.9 : false;
    var on = this.stickyEnabled && window.scrollY > 600 && !past;
    bar.style.opacity = on ? '1' : '0';
    bar.style.transform = on ? 'none' : 'translateY(24px)';
  };

  /* ------------------------------------------------------------------ boot */

  function mount(scope) {
    (scope || document).querySelectorAll('[data-pship-root]').forEach(function (root) {
      if (INSTANCES.has(root)) return;
      INSTANCES.set(root, new Partnership(root));
    });
  }

  function unmount(scope) {
    (scope || document).querySelectorAll('[data-pship-root]').forEach(function (root) {
      var inst = INSTANCES.get(root);
      if (!inst) return;
      inst.destroy();
      INSTANCES.delete(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      mount();
    });
  } else {
    mount();
  }

  // theme editor re-renders the section in place
  document.addEventListener('shopify:section:load', function (e) {
    mount(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    unmount(e.target);
  });
})();
